(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name summary.controller:SummaryContactModalCtrl
   *
   * @description
   *
   */
  angular
    .module('summary')
    .controller('SummaryContactModalCtrl', SummaryContactModalCtrl);

  SummaryContactModalCtrl.$inject = ['$uibModalInstance', 'DataService', '$log', 'FileSaver'];

  function SummaryContactModalCtrl($uibModalInstance, dataService, $log, fileSaver) {
    var vm = this;
    vm.ctrlName = 'SummaryContactModalCtrl';
    vm.ok = ok;
    vm.cancel = cancel;
    vm.contactInfo = {
      name: dataService.getQuestionByFlag('name').answer,
      phoneTime: 'anytime'
    };
    vm.isSubmissionInProgress = false;
    vm.setPreferredContactMethod = setPreferredContactMethod;
    vm.data = dataService.data;
    vm.phoneNumberPattern = dataService.phoneNumberPattern;
    vm.emailPattern = dataService.emailPattern;
    vm.updatePhoneNumber = updatePhoneNumber;
    vm.isSubmitDisabled = isSubmitDisabled;
    vm.forms = {};
    vm.openQuoteSummaryPdf = openQuoteSummaryPdf;

    activate();

    function activate() {
      vm.data.quoteConfirmationResponse = undefined;
    }

    function setPreferredContactMethod(preference) {
      vm.contactInfo.preferredMethod = preference;
    }

    function ok() {
      $log.debug('Submit called!');
      vm.isSubmissionInProgress = true;
      dataService.sendQuoteConfirmation(vm.contactInfo);
    }

    function cancel() {
      $uibModalInstance.dismiss('Cancel called.');
    }

    function updatePhoneNumber() {
      vm.contactInfo.phoneNumber = dataService.formatPhoneNumber(vm.contactInfo.phoneNumber);
    }

    function isSubmitDisabled() {
      return vm.isSubmissionInProgress ||
        vm.contactInfo.preferredMethod === 'Email' && (vm.forms.oqsContactEmail && vm.forms.oqsContactEmail.$invalid) ||
        vm.contactInfo.preferredMethod === 'Phone' && (vm.forms.oqsContactPhone && vm.forms.oqsContactPhone.$invalid);
    }

    function openQuoteSummaryPdf() {
      var pdfBlob = dataService.base64StringToBlob(vm.data.quoteConfirmationResponse.data.quotePdf, 'application/pdf');
      fileSaver.saveAs(pdfBlob, vm.data.quoteConfirmationResponse.data.quoteFileName);
    }
  }
}());
